import React from 'react';
import { Input, Select, Icon, Button, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

const { Option } = Select;
const InputGroup = Input.Group;

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.codigoReferencia} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("codigoReferencia", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar código de referencia"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <InputGroup compact>
                            <Select showSearch labelInValue
                                value={this.props.filter.idPlanCuentaVenta ? { key: this.props.filter.idPlanCuentaVenta } : undefined}
                                style={{ width: `calc(100% - 40px)` }}
                                placeholder={"Búsqueda de Cuenta Contable"}
                                optionFilterProp="children"
                                showArrow={false}
                                onSearch={this.props.onSearchAutocomplete}
                                onChange={this.props.onChangeAutocomplete}
                            >
                                {this.props.planesCuenta.map(item => (
                                    <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                ))}
                            </Select>
                            <Button
                                className="btn-autocomplete"
                                style={{ width: '40px', fontSize: '14px' }}
                                icon={this.props.filter.idPlanCuentaVenta ? 'close' : 'search'}
                                onClick={this.props.onClearAutocomplete}
                            />
                        </InputGroup>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;